import React, { lazy, Suspense, ComponentType } from "react";

const lazyLoadable = <P extends {}>(
  importFunc: () => Promise<{ default: React.ComponentType<P> }>,
  { fallback = null }: { fallback?: React.ReactNode } = {}
) => {
  const LazyComponent = lazy(importFunc);

  return (props: P) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...(props as any)} />
    </Suspense>
  );
};

export default lazyLoadable;
